export enum SeasonPoolTableColumns {
  AbbreviationLatin = "abbreviationLatin",
  AbbreviationLocal = "abbreviationLocal",
  ExternalId = "externalId",
  NameLatin = "nameLatin",
  NameLocal = "nameLocal",
  PoolCode = "poolCode",
  PoolOrder = "poolOrder",
  StageName = "stageName",
}
